module.exports = __webpack_public_path__ + "static/media/test.41447bfe.mp3";